import { MODERATOR_ABOUT_PROJECT } from "../mock/URLs";
import { api } from "./api";

export const getAboutProject = async () => {
    try {
        const { data } = await api.get(MODERATOR_ABOUT_PROJECT);
        return data.data;
    } catch (e) {
        throw e;
    }
}

export const getAboutProjectById = async (id) => {
    try {
        const { data } = await api.get(`${MODERATOR_ABOUT_PROJECT}${id}/`);
        return data.data;
    } catch (e) {
        throw e;
    }
}

export const updateAboutProject = async (id, values: any) => {
    try {
        const {data} = await api.patch(`${MODERATOR_ABOUT_PROJECT}${id}/`, values);
        return data.data;
    } catch (e) {
        throw e;
    }
}

export const createAboutProject = async (values: any) => {
    try {
        const { data } = await api.post(MODERATOR_ABOUT_PROJECT, values);
        return data;
    } catch (e) {
        throw e;
    }
}